import { RequestStatus } from '../service-proxies';


export class AllRequestDto implements IAllRequestDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    createdOn!: Date | undefined;
    status!: RequestStatus;

    constructor(data?: IAllRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AllRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAllRequestDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    createdOn: Date | undefined;
    status: RequestStatus;
}

